// Plain-English text for Firebase Auth errors. The raw messages look like
// "Firebase: Error (auth/invalid-credential)." and were shown to players
// as-is. With email enumeration protection on, a wrong password and an
// unknown email both come back as auth/invalid-credential, so the login
// message deliberately covers both.
const MESSAGES = {
  'auth/invalid-credential': 'Incorrect email or password.',
  'auth/wrong-password': 'Incorrect email or password.',
  'auth/user-not-found': 'Incorrect email or password.',
  'auth/invalid-email': 'Enter a valid email address.',
  'auth/missing-email': 'Enter your email address.',
  'auth/missing-password': 'Enter a password.',
  'auth/email-already-in-use': 'An account with that email already exists. Try signing in.',
  'auth/weak-password': 'Choose a longer password.',
  'auth/password-does-not-meet-requirements': 'Choose a longer password.',
  'auth/too-many-requests': 'Too many attempts. Wait a few minutes and try again.',
  'auth/network-request-failed': 'Could not reach the server. Check your connection and try again.',
  'auth/user-disabled': 'This account has been disabled.',
};

/**
 * @param {unknown} error  anything thrown by the Firebase Auth SDK
 * @param {string} [fallback]
 * @returns {string}
 */
export function authErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  const code = error && typeof error === 'object' && typeof error.code === 'string' ? error.code : '';
  return MESSAGES[code] || fallback;
}
